import { render, staticRenderFns } from "./ModalFormRulesComponent.vue?vue&type=template&id=1d46fc86&scoped=true"
import script from "./ModalFormRulesComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormRulesComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalFormRulesComponent.vue?vue&type=style&index=1&id=1d46fc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46fc86",
  null
  
)

export default component.exports